export var aura = [
 {
   "Day": 1,
   "Course": "Mindfulness",
   "Title": "How to Sit",
   "Description": "This meditation was designed with the beginner in mind. It will guide you through the basics of how to sit in meditation and help you to start developing your practice.",
   "Author": "Happiness Insight",
   "ID": "hi1",
   "path": "How to Sit.html"
 },
 {
   "Day": 2,
   "Course": "Mindfulness",
   "Title": "Beginner's Mind",
   "Description": "There's a Chinese saying which states \"Renew yourself, completely each day. Do it again, and forever again.\" In this session we view our whole body as though it's brand new, no previous stories attached. Discover a new, curious relationship with your body, your mind and your life today.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e136",
   "path": "Beginner_s Mind.html"
 },
 {
   "Day": 3,
   "Course": "Mindfulness",
   "Title": "Body Scan",
   "Description": "Give your mind and body the gift of compassionate presence through this core mindfulness practice.",
   "Author": "Ryan James Kenny",
   "ID": "r6",
   "path": "Body Scan - Ryan James.html"
 },
 {
   "Day": 4,
   "Course": "Mindfulness",
   "Title": "Breath Sensing",
   "Description": "This guided meditation will help quiet your mind and settle your nervous system by paying attention to your breath. Breath sensing is an effective way to calm down and refocus, and can be used anytime, anywhere to return to your center.",
   "Author": "Cassandra Carlopio",
   "ID": "-Kr3D9jPCHwW31EQ2lxK",
   "path": "Breath Sensing.html"
 },
 {
   "Day": 5,
   "Course": "Mindfulness",
   "Title": "Body Sweep Part by Part",
   "Description": "Practice giving your full attention to your body, part by part.",
   "Author": "Lisa Pollard",
   "ID": "lp4",
   "path": "Body Sweep Part by Part.html"
 },
 {
   "Day": 6,
   "Course": "Mindfulness",
   "Title": "Naming Thoughts",
   "Description": "There is a common misconception about meditation that it is all about \"stopping thoughts.\" But that can be an exercise in frustration, since our minds are accustomed to thinking. Rather, mindfulness is about bringing our full awareness to whatever is present for us, including our thoughts. In this meditation, you will practice naming the kinds of thoughts coming up for you. You will learn how to be the observer of your own thinking, which ultimately will allow you to respond to events in your life with wisdom, rather than being a reaction to them.",
   "Author": "Christina McMahon (Aura)",
   "ID": "b47",
   "path": "Naming Thoughts.html"
 },
 {
   "Day": 7,
   "Course": "Mindfulness",
   "Title": "Sounds",
   "Description": "When you meditate, it is always helpful to have something to anchor your attention to. Usually, that is your breathing. In this meditation, however, you will use the sounds in your environment as your attention anchor. This will train you to be more in tune with your senses and can create a deeper sense of awareness in your everyday life.",
   "Author": "Christina McMahon (Aura)",
   "ID": "b38",
   "path": "Sounds.html"
 },
 {
   "Day": 8,
   "Course": "Mindfulness",
   "Title": "Everyday Mindfulness",
   "Description": "A natural byproduct of mindfulness is becoming aware of what is in the moment and what's possible. It's not to change us but to help us hold presence. This ancient technique of gazing is a potent mindfulness practice in order to grow consciousness and to cultivate fierce focus. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "b31",
   "path": "Everyday Mindfulness.html"
 },
 {
   "Day": 9,
   "Course": "Mindfulness",
   "Title": "Muscle Relaxation",
   "Description": "Feeling stressed or tight? This practice will help you identify and release muscular tension.",
   "Author": "Lyndi Smith",
   "ID": "l3",
   "path": "Muscle Relaxation.html"
 },
 {
   "Day": 10,
   "Course": "Mindfulness",
   "Title": "Lovingkindness for Ourself and Others",
   "Description": "Loving yourself and others around you is one of the simplest yet most powerful way to bring happiness to yourself.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e72",
   "path": "Lovingkindness for Ourself and Others.html"
 },
 {
   "Day": 1,
   "Course": "Refreshing ",
   "Title": "Awakening Factor of Joy",
   "Description": "By returning to our practice, time after time, we can realise a peaceful and heart-fufilling life. A permanent and deep joy naturally bubbles up and we feel that spread all over our bodies. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e22",
   "path": "Awakening Factor of Joy.html"
 },
 {
   "Day": 4,
   "Course": "Refreshing ",
   "Title": "Breath Mindfulness",
   "Description": "Focus on your breathing as you breath gently. There is nothing else to do except notice that you are breathing. Allowing your experience to be simple and nourishing. ",
   "Author": "Kristy Arbon (Aura) ",
   "ID": "b20",
   "path": "Breath Mindfulness.html"
 },
 {
   "Day": 2,
   "Course": "Refreshing ",
   "Title": "Be with Open Awareness",
   "Description": "A broad awareness practice, to help us be with the whole of our present moment experience. ",
   "Author": "Mark Quirk",
   "ID": "-KqE-alcVOt93b8JYqvb",
   "path": "Be with Open Awareness.html"
 },
 {
   "Day": 3,
   "Course": "Refreshing ",
   "Title": "Becoming ",
   "Description": "This session is about becoming something that you know you can be. Whether it's having more patience, being more compassionate - whatever it is - climb into the moment with a little more attention and a little more care. In this session a internal body scan technique is used to release resistence and soften into what you are and what you're becoming. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e107",
   "path": "Becoming.html"
 },
 {
   "Day": 5,
   "Course": "Refreshing ",
   "Title": "Daily Refresh ",
   "Description": "Give yourself a time to refresh your perspective taking in the stillness of the moment, when we can feel deeply comfortable, relaxed and at ease. ",
   "Author": "Happiness Insight",
   "ID": "hi6",
   "path": "Good Morning.html"
 },
 {
   "Day": 6,
   "Course": "Refreshing ",
   "Title": "Gratitude For The People In Your Life",
   "Description": "Learn to offer gratitude to someone who has been good to you, cultivate and savour feelings of kindness and appreciation as a way to support your own wellbeing.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e81",
   "path": "Gratitude For The People In Your Life.html"
 },
 {
   "Day": 7,
   "Course": "Refreshing ",
   "Title": "Light",
   "Description": "Cultivate peace from within and share the light with everyone around you through this powerful visualisation practice. ",
   "Author": "Ryan James Kenny",
   "ID": "r4",
   "path": "Light.html"
 },
 {
   "Day": 8,
   "Course": "Refreshing ",
   "Title": "Sink into Stillness",
   "Description": "Underneath the busyness of our lives and our minds, there is a calm pool of stillness that we can always dip into. In this meditation you will connect with that stillness and return recharged and rejuvenated after this session. ",
   "Author": "Christina McMahon",
   "ID": "cd10",
   "path": "Sink Into Stillness.html"
 },
 {
   "Day": 9,
   "Course": "Refreshing ",
   "Title": "Spaciousness",
   "Description": "Space is everywhere. It's open, accepting, infinite, and indestructible. Tap into these freeing qualities as you open up to the spaciousness within you and around you.",
   "Author": "Ryan James Kenny",
   "ID": "-KpXhQlgYf2CwfkwIbwl",
   "path": "Spaciousness.html"
 },
 {
   "Day": 10,
   "Course": "Refreshing ",
   "Title": "Thank You",
   "Description": "In this session we find an easy, natural breathing pattern and attach an affirmation of gratitude, \"thank you\". It's a general thank you, and a full on inquiry into what it is you can be thankful for. Gratitude is the understanding that so many things have come together for us to just take one more breath, and that we're a part of something that is a privilege.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e41",
   "path": "Thank You.html"
 },
 {
   "Day": 1,
   "Course": "Focus",
   "Title": "21-Breaths Meditation ",
   "Description": "This short meditation practice can be helpful at times when the mind is really active, agitated or restless. By engaging the mind in focusing on a breathing routine and counting each breath up to twenty-one, the mind is encouraged to become calmer and more focussed. However, our intention is merely to encourage the mind, not to force it. We are approaching the practice with a sense of non-striving, allowing the mind to be as it is; if it is willing to settle, that’s fine, if not, that’s fine too – we simply notice it’s activity. If you become distracted and lose track of counting at any point, or if you reach twenty-one, simply begin again at one, and any time you wish to, simply let go of counting and observe the breath.",
   "Author": "William James Davies, DCMT",
   "ID": "-Kr7nvf3aTlO2-BB2K_4",
   "path": "21-Breaths Meditation.html"
 },
 {
   "Day": 2,
   "Course": "Focus",
   "Title": "Awareness of Sounds",
   "Description": "When we are beginning a meditation practice, we tend to have the idea that sounds are a distraction and we desire a perfectly tranquil, or soundproofed setting, for our spiritual endeavors. We should overcome that and learn how to be present in the moment, exactly as it is. If sounds are part of that present moment, use them as an object of focus to help turn your attention inward.",
   "Author": "Hilary Jackendoff",
   "ID": "-Krsk6E8H2wm2bJEID6t",
   "path": "Awareness of Sounds.html"
 },
 {
   "Day": 3,
   "Course": "Focus",
   "Title": "Body Scan",
   "Description": "Want to relax or refresh? The body scan is a relaxing way to become present by noticing bodily sensations.",
   "Author": "Lyndi Smith",
   "ID": "l10",
   "path": "Body Scan - Lyndi.html"
 },
 {
   "Day": 4,
   "Course": "Focus",
   "Title": "Breath & Sounds",
   "Description": "Pay attention to your breath and the sounds around you to increase focus.",
   "Author": "Lisa Pollard",
   "ID": "lp6",
   "path": "Breath _ Sounds.html"
 },
 {
   "Day": 5,
   "Course": "Focus",
   "Title": "Calm Inward Focus",
   "Description": "Gather yourself inward and for a few precious moments, stop focusing on the external environment and what's going on there. This session will give you intentional inward focus. We use a classical and effective yogic breathing technique to hone our focus and calm the mind. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e124",
   "path": "Calm Inward Focus.html"
 },
 {
   "Day": 6,
   "Course": "Focus",
   "Title": "Mindful Listening Meditation",
   "Description": "This meditation helps you to cultivate your present moment awareness. ",
   "Author": "Carla-Jo Geraghty",
   "ID": "-KpqM6NnPOWMiPfazwBO",
   "path": "Mindful Listening Meditation.html"
 },
 {
   "Day": 7,
   "Course": "Focus",
   "Title": "The Art of Stillness",
   "Description": "Experience the art and beauty of stillness in your mind and body so that you may experience a deeper calm that exists within you. ",
   "Author": "Dorothy Ratusny",
   "ID": "-KsWjlnpMIaScf3xkTxe",
   "path": "The Art of Stillness.html"
 },
 {
   "Day": 8,
   "Course": "Focus",
   "Title": "Three-Step Being Space",
   "Description": "Feeling a little overwhelmed or stuck? Use these 3 steps of awareness to create just enough space to make a decision about your next life steps.",
   "Author": "Mark Quirk",
   "ID": "-KqE8XxbYQuWS9e2yjHf",
   "path": "Three-Step Being Space.html"
 },
 {
   "Day": 9,
   "Course": "Focus",
   "Title": "Visualize Your Goals",
   "Description": "Do you have a cherished goal you're working toward? Visualisation is a powerful tool to get you focused and clear about achieving your goals. In order to \"be it,\" you have to be able to \"see it.\" Step into your best life with this powerful visualisation technique.",
   "Author": "C + D (Christina + Darrin)",
   "ID": "-KsOJxY1rZyyLWXAYTDK",
   "path": "Visualize Your Goals.html"
 },
 {
   "Day": 10,
   "Course": "Focus",
   "Title": "Waves of Breath",
   "Description": "Pause for a few minutes to let the breath wash away stress and bring you back to the present.",
   "Author": "Ryan James Kenny",
   "ID": "-Kpmuh_YqL9tYvY1Jb3O",
   "path": "Waves of Breath.html"
 },
 {
   "Day": 1,
   "Course": "Happiness",
   "Title": "Heart Light",
   "Description": `Find your true heart light`,
   "Author": "C + D (Christina + Darrin)",
   "ID": "cd9(3)",
   "path": "Heart Light.html"
 },
 {
   "Day": 2,
   "Course": "Happiness",
   "Title": "Appreciative Joy",
   "Description": "In our world today we are subtly taught to focus on the flaws in others. But when we start re-training our brains to notice their goodness instead, we are actually investing in our own happiness. When we are able to notice others' virtues, we are better able to appreciate it in ourselves as well. That appreciation for goodness is what we will be practicing in this meditation.",
   "Author": "Christina McMahon (Aura)",
   "ID": "b40",
   "path": "Appreciative Joy.html"
 },
 {
   "Day": 3,
   "Course": "Happiness",
   "Title": "Attention to Happiness",
   "Description": "In this session we feel the sense of an inner smile radiating throughout the entire body, mind and more. We imagine pulsating cells brimming with joy and bliss. We will use breath and watch thoughts and sensations as they change, bringing a deep sense of enlivenment. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e4",
   "path": "Attention to Happiness.html"
 },
 {
   "Day": 4,
   "Course": "Happiness",
   "Title": "Comfortable Here",
   "Description": "Negative thoughts? This practice helps us direct attention away from thinking and enjoy comfortable sensations we may not be noticing.",
   "Author": "Lyndi Smith",
   "ID": "l6",
   "path": "Comfortable Here.html"
 },
 {
   "Day": 5,
   "Course": "Happiness",
   "Title": "Cultivating Joy",
   "Description": "Want to increase your happiness quota today? It may be as simple as tapping into the joy that others are experiencing. When you can do this with an open heart, it is an important corrective to feelings of envy. When you can feel genuine happiness for another person's win, you are communicating a new belief in abundance that there's more than enough happiness to go around.",
   "Author": "Christina McMahon (Aura)",
   "ID": "b35",
   "path": "Cultivating Joy.html"
 },
 {
   "Day": 6,
   "Course": "Happiness",
   "Title": "Gratitude",
   "Description": "Practice gratitude to cultivate happiness in your life.",
   "Author": "Heather Prete",
   "ID": "hp2",
   "path": "Gratitude.html"
 },
 {
   "Day": 7,
   "Course": "Happiness",
   "Title": "Gratitude Meditation",
   "Description": "It's so easy to wish that our lives were different - that we had a different job, lived in a different place or had a different partner. This is so often our pattern - break free of that pattern by acknowledging it when it arises and consciously cultivating gratitude. ",
   "Author": "Hilary Jackendoff",
   "ID": "-KrsjDZENifwb40CH-EL",
   "path": "Gratitude Meditation.html"
 },
 {
   "Day": 8,
   "Course": "Happiness",
   "Title": "Light of Lovingkindness",
   "Description": "Lovingkindness is the essence of a happy life. By generating boundless heart energy for ourselves and others, we open a gateway for more love to flow to us.",
   "Author": "Christina McMahon",
   "ID": "cd5",
   "path": "Light of Lovingkindness.html"
 },
 {
   "Day": 9,
   "Course": "Happiness",
   "Title": "Lovingkindness for a Friend",
   "Description": "Open the heart and mind and deepen your sense of connection with this lovingkindness practice directed towards a dear friend.  ",
   "Author": "Pause Meditation",
   "ID": "-Kq4taDGjhykrzvCgCEB",
   "path": "Loving-Kindness for a Friend.html"
 },
 {
   "Day": 10,
   "Course": "Happiness",
   "Title": "Offering Out Compassion and Lovingkindness",
   "Description": "When we're feeling great, when our own cup is full of feelings of well-being, we can make ourselves even happier by offering those feelings of kindness and well-being out to other people.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e68",
   "path": "Offering Out Compassion and Lovingkindness.html"
 },
 {
   "Day": 1,
   "Course": "Selflove",
   "Title": "A Moment of Self-Appreciation to Use Later",
   "Description": "Allowing yourself to feel some appreciation for yourself. Things that you've done in your life have lead to you feeling this way. Allow yourself to delight in yourself and all of your good work, and then save this feeling for a time when you'll need it in the future.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e84",
   "path": "A Moment of Self-Appreciation to Use Later.html"
 },
 {
   "Day": 2,
   "Course": "Selflove",
   "Title": "May You Have Everything You Need",
   "Description": "Sit with yourself, be with yourself for a few minutes and offer yourself words of support and encouragement. May you thrive, may you feel peaceful, may you remember that you are a precious human being, may you feel at ease.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e80",
   "path": "May You Have Everything You Need.html"
 },
 {
   "Day": 3,
   "Course": "Selflove",
   "Title": "Compassionate Self-talk",
   "Description": "We're so hard on ourselves. True healing takes place when we're able to show up to a given condition honestly and fully, the highs and the lows. In this session, create a hospitable space that includes kindness towards yourself.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e7",
   "path": "Compassionate Self-talk.html"
 },
 {
   "Day": 4,
   "Course": "Selflove",
   "Title": "I Am Enough",
   "Description": "This session uses slow, measured breaths to set it up so that you may do some self-inquiry. Look into the feeling of being overwhelmed and what other feelings come with it. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e131",
   "path": "I Am Enough.html"
 },
 {
   "Day": 5,
   "Course": "Selflove",
   "Title": "Just As It Is",
   "Description": "Bit by bit, tune into your inner world and notice what it's like to be you right now in your life. No need to figure anything out or fix anything, just noticing and letting it be. In this session we will use a body scan technique, allowing each part of our body to be just as it is.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e104",
   "path": "Just As It Is.html"
 },
 {
   "Day": 6,
   "Course": "Selflove",
   "Title": "Kindness to Self - Using Phrases",
   "Description": "In this kindness to self meditation we will gently cultivate a sense of warmth and kindness to ourselves. ",
   "Author": "Carla-Jo Geraghty",
   "ID": "-KsIu5LljrPj0tLf3qjj",
   "path": "Kindness to Self - Using Phrases.html"
 },
 {
   "Day": 7,
   "Course": "Selflove",
   "Title": "Manifestation and Empathetic Joy",
   "Description": "Empathetic Joy is delight in others' good fortune. When we view the world through the eyes of abundance, there's not much we can fail to attract into our own lives.",
   "Author": "Christina McMahon",
   "ID": "cd7",
   "path": "Manifestation and Empathetic Joy.html"
 },
 {
   "Day": 8,
   "Course": "Selflove",
   "Title": "Meditation for Inner Peace",
   "Description": "Experience inner peace deliberately as you choose a point of focus within your body and hold attention and awareness here. As you allow your breath to be directed into this area, feel the sensations of peacefulness throughout your body.",
   "Author": "Dorothy Ratusny",
   "ID": "-Krxk-O0zpOZ9MCZf-Xo",
   "path": "Meditation for Inner Peace.html"
 },
 {
   "Day": 9,
   "Course": "Selflove",
   "Title": "Self-Appreciation: 3 Things I Like About Myself",
   "Description": "Deep down, in the core of your being, there are some really good things about yourself that you really like - allow yourself to savour these good feelings.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e90",
   "path": "Self-Appreciation- 3 Things I Like About Myself.html"
 },
 {
   "Day": 10,
   "Course": "Selflove",
   "Title": "Worthiness",
   "Description": "This is a visualisation session. We imagine a golden spark that grows and grows, which is the energy that helps you see your self-worth and your higher self shining.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e43",
   "path": "Worthiness.html"
 },
 {
   "Day": 1,
   "Course": "Healing",
   "Title": "Boulders",
   "Description": "This is a motivating session for working through the thing that's holding you back. We use the metaphor of boulder in the center of your room that you keep ignoring. Choose what you're going to do to clear the way once and for all. Decide to change your life for the good. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e36",
   "path": "Boulders.html"
 },
 {
   "Day": 2,
   "Course": "Healing",
   "Title": "Breathing Kindness In, Releasing Difficulty Out",
   "Description": "Intentionally breathing in kindness. You especially need kindness right now and you can breathe this in for yourself. Breathing out whatever you don't need right now - intentionally letting go of any difficulty.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e56",
   "path": "Breathing Kindness In_ Releasing Difficulty Out.html"
 },
 {
   "Day": 3,
   "Course": "Healing",
   "Title": "Building Resilience",
   "Description": "Sometimes it can feel like we're going through life pushing a boulder uphill that's three times the size of us. There are so many things all at once and we can get overwhelmed. This session isn't about fixing it all, because we'll never really stop pushing that boulder. However this session will teach you how to become so much more resilient and stronger, so that the uphill game of life is less burdensome.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e37",
   "path": "Building Resilience.html"
 },
 {
   "Day": 4,
   "Course": "Healing",
   "Title": "Filled",
   "Description": "In this session, we close our eyes and go through the whole body piece by piece, filling it with light. We bring relaxed and vibrant attention into the body, and we settle the mind. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e99",
   "path": "Filled.html"
 },
 {
   "Day": 5,
   "Course": "Healing",
   "Title": "Freakout Formula",
   "Description": "This session will offer you a simple and profound freakout formula. See through your reactivity and ease your sufferring. These are steps to use mindfulness to help get out in front of the freaking out. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e20",
   "path": "Freakout Formula.html"
 },
 {
   "Day": 6,
   "Course": "Healing",
   "Title": "Letting Go of Resistance ",
   "Description": "When we fight our reality or struggle against change, we can inadvertently create more suffering for ourselves. By allowing ourselves to let go and accept things as they are, we suffer less. This meditation is designed to help you let go of the things that you can't control through the use of your body and mind. ",
   "Author": "Happiness Insight",
   "ID": "-Ksdh0wWxnyxA7vaXU8n",
   "path": "Letting Go of Resistance.html"
 },
 {
   "Day": 7,
   "Course": "Healing",
   "Title": "Reinforcements",
   "Description": "In this session, we bring in all the reinforcements. Bring in your special memories, places, and people that give you a sense of peace and well-being and evoke feelings of comfort and rest. As the sense of ease and security remains, you'll discover that you have these inner resources with you all of the time. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e12",
   "path": "Reinforcements.html"
 },
 {
   "Day": 8,
   "Course": "Healing",
   "Title": "Self Compassion Break",
   "Description": "Learn to take a self-compassion break in your day. You deserve it! ",
   "Author": "Dea Rivera",
   "ID": "-Kqhcwmo7WUXVz8cmrwc",
   "path": "Self Compassion Break.html"
 },
 {
   "Day": 9,
   "Course": "Healing",
   "Title": "Soften and Let Go Again",
   "Description": "This session begins with deep breathing to make it easier to soften and loosen the grip physically, mentally, emotionally, and spiritually.",
   "Author": "Lauren Ziegler",
   "ID": "-KsP1iYUGYIV9VrUQZdf",
   "path": "Soften and Let Go Again.html"
 },
 {
   "Day": 10,
   "Course": "Healing",
   "Title": "This Emotion is not Me or Mine",
   "Description": "We don't choose to have difficult emotions. They are not ours to claim. We didn't create them, we can release them, and they don't define us. We can find a little relief in the moment by choosing to not hang on to difficult emotions.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e67",
   "path": "This Emotion is not Me or Mine.html"
 },
 {
   "Day": 1,
   "Course": "Relaxation",
   "Title": "Being Rocked by the Breath",
   "Description": "Noticing the gentle rhythm of your breathing, the way your body is sweetly rocked by the breath like a child being rocked in their parent's arms, allowing your body to be caressed by the breath.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e64",
   "path": "Being Rocked by the Breath.html"
 },
 {
   "Day": 2,
   "Course": "Relaxation",
   "Title": "Belly Breathing",
   "Description": "This session is focused on physically expanding your breathing. Breathing this way into the low abdomen will help calm emotions and the mind.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e96",
   "path": "Belly Breathing.html"
 },
 {
   "Day": 3,
   "Course": "Relaxation",
   "Title": "Body Scan",
   "Description": "This body scan trains awareness and opens capacity for feeling more subtly. It trains the ability to hone in and feel more concentrated and then widen to allow your awareness to include a broader span. It can have the side effect of relieving pain and anxiety. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "b2",
   "path": "Body Scan.html"
 },
 {
   "Day": 4,
   "Course": "Relaxation",
   "Title": "Letting Go of the Work Day",
   "Description": "When we transition from our work day to home, we can sometimes take home the work frustrations and stress from our day, and let it impact our home life. This meditation helps you to enter the \"third space\", a transitionary space that allows us to let go of work and our busy day, and enter into a new and replenished headspace. ",
   "Author": "Happiness Insight",
   "ID": "-Kqta0rtBcIYBpN3D5_P",
   "path": "Letting Go of the Work Day.html"
 },
 {
   "Day": 5,
   "Course": "Relaxation",
   "Title": "Letting Go Waterfall ",
   "Description": "This session uses a breathing practice to create the effect of a longer exhale. This has a soothing effect on the nervous system, calming the body and mind. It's a specific yoga technique to connect you with yourself in a safe way. It's especially helpful for those times we want to go to sleep, let go more, be clearer, or speak when needed.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e125",
   "path": "Letting Go Waterfall.html"
 },
 {
   "Day": 6,
   "Course": "Relaxation",
   "Title": "One Breath At A Time",
   "Description": "Distracted? Restless? This practice helps us become present by taking things one breath at a time.",
   "Author": "Lyndi Smith",
   "ID": "l9",
   "path": "One Breath At A Time.html"
 },
 {
   "Day": 7,
   "Course": "Relaxation",
   "Title": "Release",
   "Description": "This session uses a yogic breathing technique that is cooling to the body and has a deep effect of calming the nervous system, difficult emotions, and even soothes inflamation and pain in the body. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e94",
   "path": "Release.html"
 },
 {
   "Day": 8,
   "Course": "Relaxation",
   "Title": "Relaxation",
   "Description": "Relaxation is an art and a science. By relaxation, we mean a release of tension in both the mind and the body for a period of time to allow complete rest and revitalisation. Like sleep, only these days we tend to go to bed with so much tension that we wake up feeling exhausted. It's a life changing thing to get to relax.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e9",
   "path": "Relaxation.html"
 },
 {
   "Day": 9,
   "Course": "Relaxation",
   "Title": "Releasing Tension from the Body",
   "Description": "This practice involves letting tension go from each part of the body sequentially.",
   "Author": "Suzie Brown",
   "ID": "-KqmVgS6yx2vqT6FXbI0",
   "path": "Releasing Tension from the Body.html"
 },
 {
   "Day": 10,
   "Course": "Relaxation",
   "Title": "Soothing Breath",
   "Description": "Feeling tense? This practice helps us let go of tension and relax our mind and body.",
   "Author": "Lyndi Smith",
   "ID": "-KpprCahe4rGNmbmQncQ",
   "path": "Soothing Breath.html"
 },
 {
   "Day": 1,
   "Course": "Stress",
   "Title": "Be a Tree",
   "Description": "Imagine placing your back up against a large tree, feeling supported and steady. We use all the senses to imagine this tree and the warmth of the sun nourishing down into the trunk, to the roots. Relax into the tree and feel the sunlight nourishing you from the top of your head down into your feet. This is a meditation for becoming sturdy and grounded for when you're feeling under the weather or need some inspiration.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e93",
   "path": "Be a Tree.html"
 },
 {
   "Day": 2,
   "Course": "Stress",
   "Title": "Calmness in Mind and Body",
   "Description": "Calm your mind and body during stressful times. ",
   "Author": "Dorothy Ratusny",
   "ID": "d9",
   "path": "Calmness in Mind and Body.html"
 },
 {
   "Day": 3,
   "Course": "Stress",
   "Title": "Equanimity in You",
   "Description": "The only thing constant in life is change. So even when you are going through something difficult, you can take comfort in the fact that your life is always changing, and even difficult emotions eventually transform. We are all in a constant state of flux. When you can approach life from this perspective, you start living on an even keel, and even the most challenging of emotions don't seem so overwhelming.",
   "Author": "Christina McMahon (Aura)",
   "ID": "e53",
   "path": "Equanimity in You.html"
 },
 {
   "Day": 4,
   "Course": "Stress",
   "Title": "I Need to Take a Breather",
   "Description": "There are certain times in the day when we just need to take a breath and reconnect with ourselves. This meditaiton helps you to step out of the busyness of your day and gain back some clarity. ",
   "Author": "Happiness Insight",
   "ID": "hi2",
   "path": "I Need to Take a Breather.html"
 },
 {
   "Day": 5,
   "Course": "Stress",
   "Title": "Shifting from \"Doing\" to \"Being\"",
   "Description": "Are you firmly in \"doing\" mode today? Find some stress relief by giving yourself three minutes to sink into \"being.\" After you rejuvenate yourself, the action that you take today will be much more effective.",
   "Author": "C + D (Christina + Darrin)",
   "ID": "-KrNEFJ4vZygme71d56Z",
   "path": "Shifting from _Doing_ to _Being_.html"
 },
 {
   "Day": 6,
   "Course": "Stress",
   "Title": "Slowing Down in a Busy Day",
   "Description": "Our lives are busy. We tend to spend a lot of our day rushing from one thing to the next. This meditation allows you to slow down, find peace and serenity, and is particularly helpful if you have been feeling stressed or overwhelmed. ",
   "Author": "Happiness Insight",
   "ID": "-KsAEVTtVKqEx-8dqj8Q",
   "path": "Slowing Down in a Busy Day.html"
 },
 {
   "Day": 7,
   "Course": "Stress",
   "Title": "Taking Off the Shield",
   "Description": "Imagine being in a place where you just let the stressful things drip off you. Imagine letting some of the rigidity lift up off you so your breathing flows in and out with no hindrance. In this session we take off the shield and focus on ease of breathing. ",
   "Author": "Lauren Ziegler",
   "ID": "-KrECP1Nz_TtlY7D2N5L",
   "path": "Taking Off the Shield.html"
 },
 {
   "Day": 8,
   "Course": "Stress",
   "Title": "Thoughts on a Leaf",
   "Description": "Quiet your mind with this practice as you visualize a lovely stream alongside you.  It may be helpful when your mind feels busy or emotions feel strong",
   "Author": "Dea Rivera",
   "ID": "-KsHBNpfqyvomcc98SH7",
   "path": "Thoughts on a Leaf.html"
 },
 {
   "Day": 9,
   "Course": "Stress",
   "Title": "Time Alone in Nature ",
   "Description": "This is a visualisation session. We bring to mind a special place in nature and access the feelings this place provides. This is about cultivating an \"inner resource\" by recalling the feeling of time alone in nature. ",
   "Author": "Lauren Ziegler",
   "ID": "-KrEE4frzzd3ZZcHV-4P",
   "path": "Time Alone in Nature .html"
 },
 {
   "Day": 10,
   "Course": "Stress",
   "Title": "Systematic Body Relaxation",
   "Description": "A stressed mind automatically implies a stressed body. In this session we work to relax the mind and body,  to help relieve stress and give you that much needed break. Recieve expert guidance in cycling your attention through your body systematically, a technique for feeling and releasing the tension that you don't need to be carrying. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e13",
   "path": "Systematic Body Relaxation.html"
 },
 {
   "Day": 1,
   "Course": "Anxiety",
   "Title": "10 Mindful Breaths",
   "Description": "Challenge yourself with this practice of breathing and counting, focusing solely on the breath. It's a simple practice, but not easy. ",
   "Author": "Dea Rivera",
   "ID": "-Kr8WOMm_AOnOrxj2YFl",
   "path": "10 Mindful Breaths.html"
 },
 {
   "Day": 2,
   "Course": "Anxiety",
   "Title": "Slowing Down",
   "Description": `When you're feeling stressed or anxious, everything seems to be moving quickly: thoughts race through your mind, and your heart may feel like it is going to explode in your chest. In this meditation, you'll intentionally slow down the breath, and then check in with your thoughts and your heart rate to see if they have also slowed.`,
   "Author": "C + D (Christina + Darrin)",
   "ID": "-KqoTTpIs4i6PHKsTaIF",
   "path": "Slowing Down.html"
 },
 {
   "Day": 3,
   "Course": "Anxiety",
   "Title": "Befriending Difficulty",
   "Description": "Overwhelmed with emotions? This practice helps us accept and let go of our struggling.",
   "Author": "Lyndi Smith",
   "ID": "l11",
   "path": "Befriending Difficulty.html"
 },
 {
   "Day": 4,
   "Course": "Anxiety",
   "Title": "Calm",
   "Description": "Calm the mind with this simple yet powerful breath meditation. ",
   "Author": "Ryan James Kenny",
   "ID": "r2",
   "path": "Calm.html"
 },
 {
   "Day": 5,
   "Course": "Anxiety",
   "Title": "Where to Park Your Mind",
   "Description": "This session is about thought management and mature perspective and will give you the gift of looking at your situation in a new way, so that you can park your mind there and move forward with hope and strength. ",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e44",
   "path": "Where to Park Your Mind.html"
 },
 {
   "Day": 6,
   "Course": "Anxiety",
   "Title": "Gentleness",
   "Description": "We use a gently expanded breathing technique to bring relaxation into parts of the body, mind and more. This yogic technique of breathing into the back body (the lungs in the back) brings a sense of tenderness and ease, while leaving your feeling energised and poised for moving softly through your day with more flexibility.",
   "Author": "Lauren Ziegler (Aura)",
   "ID": "e112",
   "path": "Gentleness.html"
 },
 {
   "Day": 7,
   "Course": "Anxiety",
   "Title": "Letting Go of Anxiety ",
   "Description": "In our daily lives, if we stop and tune in, we can often sense a background hum of anxiety or stress. This meditation has been designed to help you let go of this constant feeling of stress and anxiety, and to inside find equanimity and peace. ",
   "Author": "Happiness Insight",
   "ID": "-KsM12wH81JsVHs7jblW",
   "path": "Letting Go of Anxiety.html"
 },
 {
   "Day": 8,
   "Course": "Anxiety",
   "Title": "S T O P Meditation",
   "Description": "The STOP meditation is a simple way to reconnect to yourself physically, mentally, and emotionally. You can do this practice throughout your day whenever you feel disconnected from yourself.",
   "Author": "Bill Scheinman",
   "ID": "-KqjDZXtyL2_G3QE53E4",
   "path": "S T O P Meditation.html"
 },
 {
   "Day": 9,
   "Course": "Anxiety",
   "Title": "Relief from Anxiety",
   "Description": "Experience a simple and effective way to regulate your breath that instantly slows your breathing rate, blood pressure and heart rate - allowing you relief from anxiety.",
   "Author": "Dorothy Ratusny",
   "ID": "-KrxqdWyodGUPsx506wa",
   "path": "Relief from Anxiety.html"
 },
 {
   "Day": 10,
   "Course": "Anxiety",
   "Title": "You Are A Deeply Caring Person",
   "Description": "We need to take care of ourselves so that we can take care of the people and tasks in our life. Take a few moments to connect with yourself and to remind yourself that you are worthy of your own care and concern, and the reason you feel stressed is because you are a deeply caring person.",
   "Author": "Kristy Arbon (Aura)",
   "ID": "e62",
   "path": "You Are A Deeply Caring Person.html"
 }
];



// WEBPACK FOOTER //
// ./src/assets/aura/config/aura.config.ts